var map = {
	"./ChangeInfo.vue": 77899,
	"./ComButton.vue": 8291,
	"./ComFooter.vue": 9202,
	"./ComHeader.vue": 82942,
	"./ComNotice.vue": 33878,
	"./ComTab.vue": 78670,
	"./ComTitle.vue": 36455,
	"./DynamicCircle.vue": 57296,
	"./GlobalLoginModal - 副本.vue": 84119,
	"./GlobalLoginModal.vue": 81161,
	"./GlobalProvince.vue": 4544,
	"./ItemCourse.vue": 82586,
	"./ItemMajor.vue": 45561,
	"./ItemNews.vue": 85230,
	"./ItemUni.vue": 51041,
	"./OptionCard.vue": 45010,
	"./OptionCircle.vue": 78266,
	"./OptionMajor.vue": 5775,
	"./OptionPosition.vue": 70503,
	"./RecommendCard.vue": 19368,
	"./VipBuy.vue": 50068,
	"./VipTips.vue": 68478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3697;